export { validateEmailAddress, validateUrl } from './validators';

export function getDisplayNameString(item: { displayName: string; accessible: boolean }): string {
    return item.displayName + (item.accessible ? '' : ' (Access Restricted)');
}

export function getDisplayNamesString(
    items: { displayName: string; accessible: boolean }[],
): string {
    return items.length > 0 ? items.map(getDisplayNameString).join(', ') : '—';
}

export function setsEqual<T>(a: Set<T>, b: Set<T>): boolean {
    return a.size === b.size && a.isSubsetOf(b);
}
